import angular from 'angular';
import uiRouter from 'angular-ui-router';
import salesmenComponent from './salesmen.component';
import dataTable from 'angular-material-data-table';

let salesmenModule = angular
  .module('salesmen', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('salesmen', {
      url: '/salesmen',
      component: 'salesmen',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('salesmen', salesmenComponent).name;

export default salesmenModule;
